import { observable, action, runInAction } from 'mobx'
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant'
import emailListAPI from '../apis/emailListAPI'
import alertMessage from '../utils/alertMessage'

export default class EmailListStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []
  /*SearchResult start*/
  @observable searchItem = {
    'marketGroupId': '',
    'date': null,
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []
  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await emailListAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  async onSearchComplateAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await emailListAPI.searchComplateAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.task || []
          this.itemCount = response.data.data?.totalNum
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  //Status 下拉列表
  @observable statusList = []
  @observable sourceTypeList = []
  @action
  async onGetStatus(params) {
    if (params === 'sourceType') {
      this.sourceTypeList = []
    } else {
      this.statusList = []
    }
    try {
      const response = await emailListAPI.getStatus(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          if (params === 'sourceType') {
            this.sourceTypeList = data
          } else {
            this.statusList = data
          }
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  // 营销分组列表
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await emailListAPI.getGroup(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  // 获取模板列表
  @observable templateList = []
  @action
  async onGetTemplate(params) {
    this.templateList = []
    try {
      const response = await emailListAPI.getTemplate(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.templateList = data?.templateList || []
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  // 获取域名列表
  @observable httpList = []
  @action
  async onGetHttp(params) {
    this.httpList = []
    try {
      const response = await emailListAPI.getHttp(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.httpList = data?.data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  // 获取发送人列表
  @observable senderList = []
  @action
  async onGetSender(params) {
    this.senderList = []
    try {
      const response = await emailListAPI.getSender(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.senderList = data?.data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  @action
  onChangeSenderList(value) {
    this.senderList = value
  }
  // 获取联系人列表
  @observable concaterList = []
  @action
  async onGetConcater(params) {
    this.concaterList = []
    try {
      const response = await emailListAPI.getConcater(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.concaterList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, type, title) {
    this.isFetching = true
    try {
      const response = await emailListAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          if (type === '1') {
            this.onSearchJobAction(this.searchItem)
          } else {
            this.onSearchComplateAction(this.searchItem)
          }
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*edit*/
  @action
  async onEditJobAction(params, type, title) {
    this.isFetching = true
    try {
      const response = await emailListAPI.editAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          if (type === '1') {
            this.onSearchJobAction(this.searchItem)
          } else {
            this.onSearchComplateAction(this.searchItem)
          }
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await emailListAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const { data } = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params, type) {
    this.isFetching = true
    try {
      const response = await emailListAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          if (type === '1') {
            this.onSearchJobAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            this.onSearchComplateAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          }
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize, type) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    if (type === '1') {
      this.onSearchJobAction({
        'marketGroupId': this.searchItem.marketGroupId,
        'isPowerUser': this.searchItem.isPowerUser,
        'date': this.searchItem.date,
        'page': pageNo,
        'size': pageSize,
      })
    } else {
      this.onSearchComplateAction({
        'marketGroupId': this.searchItem.marketGroupId,
        'date': this.searchItem.date,
        'page': pageNo,
        'size': pageSize,
      })
    }
  }


  /* 活跃邮箱统计 */
  @observable isFetchingEmailTotal = false
  @observable overviewDetailResult = null
  @observable overviewResult = null
  @action
  async onEmailTotalAction(params) {
    this.isFetchingEmailTotal = true
    try {
      const response = await emailListAPI.emailTotalAction(params)
      runInAction(() => {
        this.isFetchingEmailTotal = false
        if (response.data.code === 0) {
          //this.overviewDetailResult = response.data.data?.overviewDetailResult?.userList
          this.overviewResult = response.data.data?.overviewResult
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingEmailTotal = false
      })
    }
  }
  // 发送统计
  @observable isFetchingSendTotal = false
  @observable sendTotalObj = null
  @action
  async onSendTotalAction(params) {
    this.isFetchingSendTotal = true
    try {
      const response = await emailListAPI.sendTotalAction(params)
      runInAction(() => {
        this.isFetchingSendTotal = false
        if (response.data.code === 0) {
          this.sendTotalObj = response.data.data
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingSendTotal = false
      })
    }
  }
  // 投递失败统计数据
  @observable isFetchingFailedStatistics = false
  @observable failedStatistics = []
  @action
  async onFailedStatisticsAction(params) {
    this.isFetchingFailedStatistics = true
    try {
      const response = await emailListAPI.failedStatisticsAction(params)
      runInAction(() => {
        this.isFetchingFailedStatistics = false
        if (response.data.code === 0) {
          this.failedStatistics = response.data.data?.map(a => { return { type: a?.errorTypeDec, value: a?.count } })
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingFailedStatistics = false
      })
    }
  }
  //展会届次列表
  @observable expoList = []
  @action
  async onExpoAction(params) {
    this.expoList = []
    try {
      const response = await emailListAPI.expoAction(params)
      runInAction(() => {
        if (response.data.code === 0) {
          this.expoList = response.data.data
        } else {
          alertMessage.error('重新发送失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }

  @observable isFetchingAddress = false
  @observable pageSizeAddress = PAGE_SIZE_DEFAULT
  @observable pageNoAddress = 1
  @observable currIndexAddress = 0
  @observable itemCountAddress = 0
  @observable searchItemAddress = {
    'isPowerUser': false,
    'page': this.pageNoAddress,
    'size': this.pageSizeAddress,
  }
  @observable addressList = []
  @observable handAddressList = []
  @observable fileAddressList = []
  @observable resourceAddressList = []
  @observable AddressTable = []
  @action
  async onAddressAction(params) {
    this.isFetchingAddress = true
    this.pageNoAddress = params.page
    this.pageSizeAddress = params.size
    this.itemCountAddress = 0
    this.addressList = []
    try {
      const response = await emailListAPI.addressAction(params)
      runInAction(() => {
        this.isFetchingAddress = false
        if (response.data.code === 0) {
          this.addressList = response.data.data?.records || []
          this.itemCountAddress = response.data.data?.total
          this.searchItemAddress = params
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingAddress = false
      })
    }
  }
  @action
  onChangeAddressPageNumAction(pageNo, pageSize) {
    if (this.pageNoAddress === pageNo && (!pageSize || this.pageSizeAddress === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoAddress = pageNo
      this.pageSizeAddress = pageSize
    })
    this.onAddressAction({
      ...this.searchItemAddress,
      'page': pageNo,
      'size': pageSize,
    })
  }
  /* 添加号码 */
  @action
  async onAddAddressAction(params) {
    this.isFetchingAddress = true
    try {
      const response = await emailListAPI.addAddressAction(params)
      runInAction(() => {
        this.isFetchingAddress = false
        if (response.data.code === 0) {
          alertMessage.success('添加成功！')
        } else {
          alertMessage.error('添加失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingAddress = false
      })
    }
  }
  /* 清空号码 */
  @action
  async onClearAddressAction(params) {
    this.isFetchingAddress = true
    try {
      const response = await emailListAPI.clearAddressAction(params)
      runInAction(() => {
        this.isFetchingAddress = false
        if (response.data.code === 0) {
          alertMessage.success('清空成功！')
          this.searchItemAddress = {
            ...this.searchItemAddress,
            ...params,
          }
          this.onAddressAction({
            ...this.searchItemAddress,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('清空失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingAddress = false
      })
    }
  }
  @action
  onChangeAddressTable(value) {
    this.AddressTable = value
  }

  /* 获取手机号统计结果 */
  @observable handPhoneNum = 0
  @observable validHandPhoneNum = 0
  @observable invalidHandPhoneNum = 0
  @observable filePhoneNum = 0
  @observable validFilePhoneNum = 0
  @observable invalidFilePhoneNum = 0
  @observable resourcePhoneNum = 0
  @observable validResourcePhoneNum = 0
  @observable invalidResourcePhoneNum = 0
  @action
  async onStatisticsAction(params) {
    this.isFetchingPhone = true
    try {
      const response = await emailListAPI.statisticsAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          this.handPhoneNum = response.data.data?.manualNumberTotal || 0
          this.validHandPhoneNum = response.data.data?.manualNumberValid || 0
          this.invalidHandPhoneNum = response.data.data?.manualNumberInvalid || 0
          this.filePhoneNum = response.data.data?.templateImportNumberTotal || 0
          this.validFilePhoneNum = response.data.data?.templateImportNumberValid || 0
          this.invalidFilePhoneNum = response.data.data?.templateImportNumberInvalid || 0
          this.resourcePhoneNum = response.data.data?.resourcePoolImportNumberTotal || 0
          this.validResourcePhoneNum = response.data.data?.resourcePoolImportNumberValid || 0
          this.invalidResourcePhoneNum = response.data.data?.resourcePoolImportNumberInvalid || 0
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  @action
  onChangeHandPhoneNum(value) {
    this.handPhoneNum = value
  }
  @action
  onChangeFilePhoneNum(value) {
    this.filePhoneNum = value
  }
  @action
  onChangeResourcePhoneNum(value) {
    this.resourcePhoneNum = value
  }
  @action
  onChangeAllNum(value) {
    this.allNum = value
  }
  //获取资源池的 下拉列表
  @observable resourcePoolList = []
  @action
  async onGetResourcePool(params) {
    this.resourcePoolList = []
    try {
      const response = await emailListAPI.getResourcePool(params)
      const { code, data, messageEn } = response?.data
      runInAction(() => {
        if (code === 0) {
          this.resourcePoolList = data.filter(a => a?.status === 0)
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
  /*agree*/
  @observable isFetchingAgree = false
  @action
  async onAgreeAction(params, type) {
    this.isFetchingAgree = true
    try {
      const response = await emailListAPI.agreeAction(params)
      runInAction(() => {
        this.isFetchingAgree = false
        if (response.data.code === 0) {
          alertMessage.success(params?.approveResult === '3' ? '审批成功！' : '拒绝成功！')
          if (type === '1') {
            this.onSearchJobAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            this.onSearchComplateAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          }
        } else {
          alertMessage.error(params?.approveResult === '3' ? '审批失败！' + response.data.messageEn + '' : '拒绝失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingAgree = false
      })
    }
  }
  /* 失败批次重新发送 */
  @observable isFetchingReSend = false
  @action
  async onReSendAction(params, type) {
    this.isFetchingReSend = true
    try {
      const response = await emailListAPI.reSendAction(params)
      runInAction(() => {
        this.isFetchingReSend = false
        if (response.data.code === 0) {
          alertMessage.success('重新发送成功！')
          if (type === '1') {
            this.onSearchJobAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            this.onSearchComplateAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          }
        } else {
          alertMessage.error('重新发送失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingReSend = false
      })
    }
  }
  /*查询发送数量*//* 查看地址 地址详情 */
  @observable isFetchingDetails = false
  @observable id = ""
  @observable taskId = ""
  @observable pageSizeDetails = PAGE_SIZE_DEFAULT
  @observable pageNoDetails = 1
  @observable currIndexDetails = 0
  @observable itemCountDetails = 0
  @observable searchItemDetails = {
    "id": "",
    "keyword": "",
    "taskid": "",
    "marketGroupId": this.searchItem?.marketGroupId,
    'page': 1,
    'size': PAGE_SIZE_DEFAULT
  }
  @observable detailsList = []
  @action
  async onDetailsListAction(params) {
    this.isFetchingDetails = true
    this.pageNoDetails = params.page
    this.pageSizeDetails = params.size
    this.id = params.id
    this.taskId = params.taskId
    this.itemCountDetails = 0
    this.detailsList = []
    try {
      const response = await emailListAPI.getAddressList(params)
      runInAction(() => {
        this.isFetchingDetails = false
        if (response.data.code === 0) {
          this.searchItemDetails = params
          this.detailsList = response.data.data?.addrList
          this.itemCountDetails = response.data.data?.totalNum
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetchingDetails = false
      })
    }
  }
  @action
  onChangeDetailsList(val) {
    this.detailsList = val
    this.pageNoDetails = 0
    this.pageSizeDetails = PAGE_SIZE_DEFAULT
    this.itemCountDetails = 0
  }
  @action
  onChangeDetailsPageNumAction(pageNo, pageSize) {
    if (this.pageNoDetails === pageNo && (!pageSize || this.pageSizeDetails === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoDetails = pageNo
      this.pageSizeDetails = pageSize
    })

    this.onDetailsListAction({
      "id": this.searchItemDetails.id,
      "taskId": this.searchItemDetails.taskId,
      "marketGroupId": this.searchItemDetails?.marketGroupId,
      'page': pageNo,
      'size': pageSize
    })
  }
  // 修改加载状态
  @action
  onChangeFetching(status) {
    runInAction(() => {
      this.isFetching = status
    })
  }


  // 获取发送统计信息
  @observable sendStatistics = {}
  @action
  async onGetSendStatistics(id) {
    this.sendStatistics = {}
    this.isFetching = true;
    try {
      const response = await emailListAPI.getSendStatistics({ id: id })
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        this.isFetching = false;
        if (code === 0) {
          this.sendStatistics = data ?? {};
        } else {
          alertMessage.error('获取发送统计信息失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false;
      })
    }
  }

  // 测试发送加载状态
  @observable isTestSendFetching = false
  @action
  async onSendTestEmail(params) {
    this.isTestSendFetching = true;
    try {
      const response = await emailListAPI.sendTestEmail(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        this.isTestSendFetching = false;
        if (code === 0) {
          // 0 发送成功  1 正在上传联系人  2 发送失败
          if (data===1) {
            alertMessage.warning('正在排队中，请稍候...', 5)
          } else {
            alertMessage.success('发送成功')
          }
        } else {
          alertMessage.error('发送失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isTestSendFetching = false;
      })
    }
  }
}
